import { css } from "@emotion/css";

const styles = {
  icon: css`
    font-size: 14px !important;
  `,
};

export default styles;
